/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateOrUpdateTagRequest} from '@cash-web/protos/squareup/cash/mosaic/resources/api/v2/tag.pb'
import {CreateOrUpdateTagResponse} from '@cash-web/protos/squareup/cash/mosaic/resources/api/v2/tag.pb'


export const createOrUpdateTag = (request: CreateOrUpdateTagRequest, options?: CashRequestOptions) => post<CreateOrUpdateTagRequest, CreateOrUpdateTagResponse>("/2.0/cash/create-or-update-tag", request, {...options, rejectOnError: true })